import { render, staticRenderFns } from "./PageTabsBlock.vue?vue&type=template&id=fada35c0"
import script from "./PageTabsBlock.vue?vue&type=script&lang=js"
export * from "./PageTabsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports